import { render, staticRenderFns } from "./DashboardCabangView.vue?vue&type=template&id=52d9d486&scoped=true&"
import script from "./DashboardCabangView.vue?vue&type=script&lang=js&"
export * from "./DashboardCabangView.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCabangView.vue?vue&type=style&index=0&id=52d9d486&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d9d486",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCard,VCol,VRow,VSimpleTable})
